"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconSingleWomanSetting = /*#__PURE__*/
function (_Icon) {
  _inherits(IconSingleWomanSetting, _Icon);
  function IconSingleWomanSetting(props) {
    var _this;
    _classCallCheck(this, IconSingleWomanSetting);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconSingleWomanSetting).call(this, props));
    _this.name = 'IconSingleWomanSetting';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "single-woman-setting_svg__group0"
    }, _react2.default.createElement("path", {
      className: "single-woman-setting_svg__path0",
      d: "M17.751 8.906c-1.068 0-1.937-.869-1.937-1.937s.869-1.937 1.937-1.937 1.937.869 1.937 1.937-.869 1.937-1.937 1.937zm0-2.874a.938.938 0 10.001 1.875.938.938 0 00-.001-1.875z"
    }), _react2.default.createElement("path", {
      className: "single-woman-setting_svg__path1",
      d: "M17.755 13.938a1.774 1.774 0 01-1.699-1.264l-.424-1.39a.454.454 0 00-.533-.311l-1.412.327a1.775 1.775 0 01-1.348-.231 1.782 1.782 0 01-.353-2.722l.987-1.064a.463.463 0 000-.625l-.988-1.065a1.784 1.784 0 011.698-2.953l1.417.326a.457.457 0 00.527-.311l.424-1.393A1.787 1.787 0 0117.751 0a1.77 1.77 0 011.699 1.264l.428 1.389a.457.457 0 00.534.313l1.41-.328a1.784 1.784 0 011.7 2.953l-.987 1.064a.463.463 0 000 .625l.988 1.065c.324.348.493.802.476 1.278a1.772 1.772 0 01-.567 1.242 1.777 1.777 0 01-1.214.478c-.132 0-.264-.015-.393-.044l-1.415-.328a.455.455 0 00-.532.31l-.425 1.394a1.783 1.783 0 01-1.698 1.263zm-2.556-3.977c.636 0 1.208.425 1.391 1.033l.424 1.391a.773.773 0 001.484.002l.425-1.394a1.46 1.46 0 011.715-.995l1.412.327a.781.781 0 00.951-.736.783.783 0 00-.209-.562l-.989-1.066a1.466 1.466 0 010-1.985l.988-1.065a.783.783 0 00-.744-1.298l-1.409.327a1.464 1.464 0 01-1.716-.996l-.432-1.403a.785.785 0 00-.516-.509.78.78 0 00-.965.52l-.425 1.394a1.465 1.465 0 01-1.707.995l-1.416-.329a.781.781 0 00-.742 1.298l.989 1.066a1.466 1.466 0 010 1.985l-.988 1.065a.783.783 0 00.743 1.298l1.409-.326c.109-.025.218-.037.327-.037z"
    }), _react2.default.createElement("path", {
      className: "single-woman-setting_svg__path2",
      d: "M6.001 8A3.986 3.986 0 012.06 4.664a.26.26 0 01-.012-.082A3.884 3.884 0 012.001 4c0-2.206 1.794-4 4-4s4 1.794 4 4a3.955 3.955 0 01-.059.654C9.609 6.605 7.96 8 6.001 8zM3.185 5.025A2.998 2.998 0 006.001 7c1.27 0 2.39-.8 2.817-1.977a5.129 5.129 0 01-2.817-1.329 5.125 5.125 0 01-2.816 1.331zM6.001 1c-1.654 0-3 1.346-3 3v.04a4.147 4.147 0 002.621-1.393.5.5 0 01.756 0A4.155 4.155 0 009 4.037V4a3.002 3.002 0 00-2.999-3z"
    }), _react2.default.createElement("path", {
      className: "single-woman-setting_svg__path3",
      d: "M4.49 24a.504.504 0 01-.49-.397L3.03 19H.501a.502.502 0 01-.483-.633l1.805-6.582A4.279 4.279 0 016 8.5a4.288 4.288 0 014.187 3.302l1.796 6.566a.502.502 0 01-.482.632H8.949l-.97 4.603A.503.503 0 017.49 24h-3zm2.594-1l.97-4.603a.504.504 0 01.49-.397h2.302l-1.627-5.95a3.295 3.295 0 00-.884-1.586l-1.912 3.011a.498.498 0 01-.846-.003l-1.894-3.02c-.44.433-.746.975-.891 1.583L1.156 18h2.279c.235 0 .441.167.489.397L4.895 23h2.189zM6.003 12.269l1.522-2.397a3.287 3.287 0 00-1.52-.372l-.004-.25v.25c-.525 0-1.04.125-1.506.364l1.508 2.405z"
    })));
    return _this;
  }
  return IconSingleWomanSetting;
}(_Icon3.default);
exports.default = IconSingleWomanSetting;